import { render, staticRenderFns } from "./ChatMovementList.vue?vue&type=template&id=49ac5ae6&scoped=true&"
import script from "./ChatMovementList.vue?vue&type=script&lang=js&"
export * from "./ChatMovementList.vue?vue&type=script&lang=js&"
import style0 from "./ChatMovementList.vue?vue&type=style&index=0&id=49ac5ae6&scoped=true&lang=css&"
import style1 from "./ChatMovementList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ac5ae6",
  null
  
)

export default component.exports